import React from 'react'
import InstaIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import '../styles/Footer.css';

function Footer() {
  return (
    <div className='footer'>
       <p>Follow Us On Social Media!</p> 
      <div className='socialMedia'>      
        <a href="https://www.instagram.com/signsofthegoodlife/" target='new'>
            <InstaIcon fontSize="large" sx={{ color: "white" }} />
        </a> 
        <a href="https://www.facebook.com/profile.php?id=61585177679933" target='new'>
            <FacebookIcon fontSize="large" sx={{ color: "white" }} />
        </a> 
      </div>    
      <p> &copy; 2024 Signs of the Good Life Autograph Collection</p>
      
    </div>
  )
}

export default Footer
